import { render, staticRenderFns } from "./AllHomeworkSubmissions.vue?vue&type=template&id=17edd636"
import script from "./AllHomeworkSubmissions.vue?vue&type=script&lang=js"
export * from "./AllHomeworkSubmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports